<div mat-dialog-title class="modal-title">
  <h1>Notificações</h1>
  <a (click)="onNoClick()">X</a>
</div>
<mat-dialog-content>
  @if (numRenova.length !== 0) {
    <div>
      @for (car of numRenova; track car) {
        <p (click)="openDetalhes(car.id)" style="cursor: pointer;">O CAR de ID: <strong>{{car.id}}</strong> cadastrado na data {{car.timestamp | date: 'dd/MM/yyyy'}} do úsuario ({{car.user.id}}) <strong>{{car.user.firstName + ' ' + car.user.lastName | titlecase}}</strong> deve ser revisado para renovação.</p>
      }
    </div>
  }
  @if (aguardando.length !== 0) {
    <div>
      @for (car of aguardando; track car) {
        <p (click)="openReplica(car.id)" style="cursor: pointer;">O CAR de ID: <strong>{{car.id}}</strong> do úsuario ({{car.user.id}}) <strong>{{car.user.firstName + ' ' + car.user.lastName | titlecase}}</strong> foi respondido.</p>
      }
    </div>
  }
  @if (numRenova.length === 0 && aguardando.length === 0) {
    <div>
      <p>Nenhuma nova notificação</p>
    </div>
  }
</mat-dialog-content>

